import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { useSheets } from '../api';
import { SheetPages } from '../SheetPages';

/** /api-docs and /api-docs/:sheetId — what users / resellers read. */
export function ApiDocsViewerPage() {
  const { sheetId } = useParams<{ sheetId?: string }>();
  const sheets = useSheets();

  const sheet = useMemo(() => {
    const list = sheets.data ?? [];
    return list.find((s) => String(s.id) === sheetId) ?? list[0];
  }, [sheets.data, sheetId]);

  return (
    <ScrollPage>
      <PageHeader title={sheet?.sheetName ?? 'API Docs'} />
      {sheets.isLoading && (
        <div className="flex h-64 items-center justify-center gap-2 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" /> Loading…
        </div>
      )}
      {!sheets.isLoading && !sheet && (
        <p className="text-sm text-muted-foreground">No documentation available yet.</p>
      )}
      {sheet && <SheetPages sheet={sheet} />}
    </ScrollPage>
  );
}
